<template>
  <div class="sd_content_banner">
    <el-carousel :height="bannerHeight + 'px'" ref="carousel" :interval="5000">
      <el-carousel-item
        v-for="(item, index) in infoList"
        :key="index"
        name="index"
      >
        <el-image
          style="width: 100%; height: 100%; cursor: pointer"
          :src="item.news_pic"
          fit="cover"
          @click="showDetail(item)"
        ></el-image>
        <div class="floatDiv" @click="showDetail(item)">
          <p>{{ item.news_title }}</p>
          <!-- 设置自定义悬浮指示器 -->
          <div class="floatDash">
            <p
              v-for="(item, key) in infoList"
              :key="key"
              @mouseenter="listTab(key)"
              :class="[key === index ? 'setOpacity' : 'normalOpacity']"
            ></p>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getRecommended, setVideoRecord } from "@/api/moudles/home.js";
export default {
  data() {
    return {
      infoList: [],
      bannerHeight: "350",
    };
  },
  created() {
    this.getRecommended();
  },
  mounted() {
    this.$nextTick(() => {
      const screenWidth = window.screen.width;
      if (screenWidth < 760) {
        this.bannerHeight = "265";
      }
    });
  },
  methods: {
    // 设置
    setHeight() {
      this.bannerHeight = "265";
    },
    // 还原
    resolveHeight() {
      this.bannerHeight = "350";
    },
    // 官网首页推荐咨询
    async getRecommended() {
      await getRecommended({
        success: (res) => {
          // console.log('res', res)
          this.infoList = res.data;
        },
      });
    },
    // 更换指示器
    listTab(key) {
      this.$refs.carousel.setActiveItem(key);
    },
    // 展示nav详情
    showDetail(item) {
      if (item.wx_link) {
        window.open(item.wx_link);
      } else {
        const screenWidth = window.screen.width;
        if (screenWidth < 760) {
          this.$router.push(`/phoneIndex/recomDetail/${item.id}`);
        } else {
          this.$router.push(`/recomDetail/${item.id}`);
        }
      }
      this.setVideoRecord("1", item.id);
    },
    // 提交视频播放记录
    async setVideoRecord(type, newsId) {
      await setVideoRecord({
        data: {
          type,
          newsId,
          userId: "",
        },
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .sd_content_banner {
    width: 100%;
    height: 265px;
  }
}

@media screen and (min-width: 750px) {
  .sd_content_banner {
    width: 600px;
    height: 350px;
  }
}

.floatDiv {
  position: absolute;
  bottom: 10px;
  left: 20px;
  width: calc(100% - 20px);
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  align-items: center;
}

.floatDash p {
  display: block;
  background-color: #fff;
  border-radius: 50%;
  width: 12px;
  margin: 0 10px;
  height: 12px;
}

.floatDash p:hover {
  opacity: 1 !important;
}

.floatSpan {
  position: absolute;
  top: 50px;
  left: 20px;
  width: 196px;
  height: 40px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
}

.floatP {
  position: absolute;
  display: inline-block;
  top: 100px;
  left: 20px;
  width: 250px;
  height: 92px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  font-size: 10px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #ffffff;
  line-height: 16px;
}

.floatDiv p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.floatDash {
  cursor: pointer;
  display: flex;
}

.floatDash p:hover {
  opacity: 1 !important;
}

.setOpacity {
  opacity: 1;
}

.normalOpacity {
  opacity: 0.39;
}

>>> .el-carousel__indicators {
  display: none;
}
</style>
